import { ResponseType } from 'axios';
export class SyncError extends Error {
  private errorCode: number;

  constructor(message: string, errorCode: number) {
    super(message);
    // 0 ->fail to get report
    this.errorCode = errorCode;
  }
}

export interface IAsyncRequestId {
  id: string;
}

export function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function backOffTimeCalculation(run: number = 0) {
  // run: 10 => 50s, 20 => 3min 20s, 30 => 8 min 20s  50 => 28 min 20s
  const fiveSeconds = 5000;
  if (run < 10) {
    // 5s every runs
    // 50s in first 10 runs
    return fiveSeconds;
  } else if (run < 20) {
    // 15s every runs
    // 2min 30s minutes in total in next 10 runs
    return 3 * fiveSeconds;
  } else if (run < 30) {
    // 30s every runs
    // 5 minutes in next 10 runs
    return 6 * fiveSeconds;
  } else {
    // 1min every runs
    return 12 * fiveSeconds;
  }
}

export enum AsyncErrorCodeEnum {
  FailToGetRequestId,
  FailToGetReport,
  TooManyRequestsSent,
  RequestCancelled,
  Unknown = 10,
}

export class AsyncError extends Error {
  private errorCode: AsyncErrorCodeEnum;

  constructor(message: string, errorCode: AsyncErrorCodeEnum) {
    super(message);
    // 0 ->fail to get requestId, 1->fail to get report, 2->too many request to get report. 3-> unknown Error
    this.errorCode = errorCode;
  }
}

export type FileFormat = 'PDF' | 'MHTML' | 'XLSX' | 'CSV' | 'DOCX';

export function getResponseAndContentType(fileFormat: FileFormat): {
  responseType: ResponseType;
  contentType: string;
} {
  let responseType: ResponseType;
  let contentType: string;
  switch (fileFormat) {
    case 'PDF':
      responseType = 'blob';
      contentType = 'application/pdf';
      break;
    case 'XLSX':
      responseType = 'arraybuffer';
      contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      break;
    case 'CSV':
      responseType = 'arraybuffer';
      contentType = 'text/csv';
      break;
    case 'DOCX':
      responseType = 'blob';
      contentType = ' application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    default:
      responseType = 'blob';
      contentType = 'application/pdf';
  }
  return { responseType, contentType };
}
